// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7wfMU","clinicsSelect":"styles_clinicsSelect__2gG4i"};